// extracted by mini-css-extract-plugin
export default {"message":"RecruitmentMemberArchiveConfirmModal_message__FkBk8"};